import { Component, OnInit, OnDestroy, Input, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubMenuService } from '../../../../services/submenu.service';

import { ANDROID_STORE_URL, IOS_STORE_URL } from '../../../../shared/utils/store-links';

@Component({
  selector: 'app-app-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-banner.component.html',
  styleUrl: './app-banner.component.scss',
})
export class AppBannerComponent implements OnInit, OnDestroy {
  @Input() variant: 'top' | 'bottom' = 'top';
  @Input() dismissKey: string = 'vm_app_banner_dismissed';
  @HostBinding('class.variant-bottom') get isBottom() { return this.variant === 'bottom'; }

  visible = false;
  panelOpen = false;
  platform: 'ios' | 'android' | null = null;
  private subs = new Subscription();
  private panelStates: Record<string, boolean> = {};

  constructor(private subMenuService: SubMenuService) {}

  get storeUrl(): string {
    return this.platform === 'ios' ? IOS_STORE_URL : ANDROID_STORE_URL;
  }

  get bannerText(): string {
    return 'Explore more on the app. Download Vector Marine.';
  }

  ngOnInit() {
    if (localStorage.getItem(this.dismissKey)) return;

    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/i.test(ua)) {
      this.platform = 'ios';
      this.visible = true;
    } else if (/Android/i.test(ua)) {
      this.platform = 'android';
      this.visible = true;
    }

    this.trackPanel('filter', this.subMenuService.filterOpenState$);
    this.trackPanel('layer', this.subMenuService.layerModalState$);
    this.trackPanel('waypoint', this.subMenuService.waypointModalState$);
    this.trackPanel('watch', this.subMenuService.watchPageModalState$);
    this.trackPanel('profile', this.subMenuService.userProfileOpenState$);
    this.trackPanel('messages', this.subMenuService.messagesOpenState$);
    this.subs.add(
      this.subMenuService.waypointManager$.pipe(map(v => !!v))
        .subscribe(open => this.setPanel('waypointMgr', open))
    );
  }

  private trackPanel(key: string, obs$: import('rxjs').Observable<boolean>) {
    this.subs.add(obs$.subscribe(open => this.setPanel(key, open)));
  }

  private setPanel(key: string, open: boolean) {
    this.panelStates[key] = open;
    this.panelOpen = Object.values(this.panelStates).some(Boolean);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  dismiss() {
    this.visible = false;
    localStorage.setItem(this.dismissKey, '1');
  }

  openStore() {
    window.open(this.storeUrl, '_blank');
  }
}
